module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.tooltipContainer)+'" data-playable-component></div>';return out;
} 
  };